import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import { FormSelectField } from '../../../../../../../../../semantic-ui/components/form-select-field';
import { FormInputField } from '../../../../../../../../../semantic-ui/components/form-input-field';
import '../../styles.less';
import { ErrorComponent } from '../../../../../../../../../components/error-component';
import { normalizeInteger } from '../../../../../../../../../utils/normalizeInteger';

export const CarFleetField = ({
	carFleetRows,
	carTypes,
	tonnages,
	isOptionsListLoading,
	onAddCarTypeButtonClick,
	onRemoveCarRow,
	handleFieldChange,
}) => {
	return (
		<section className="dictionary-about-form__section_transport">
			<div className="dictionary-about-form__row_transport">
				{carFleetRows.map((row, index) => {
					const isLastRow = index === carFleetRows.length - 1;

					return (
						<>
							<div key={row.id} className="dictionary-about-form__container_transport">
								<div>
									<div className="dictionary-about-form__block_transport-field_car_type">
										<Field
											key={`car_type_${row.id}`}
											name={`transports[${index}].car_type_id`}
											type="text"
											component={FormSelectField}
											autoComplete="off"
											placeholder="Тип авто"
											options={carTypes}
											loading={isOptionsListLoading.carTypes}
											disabled={isOptionsListLoading.carTypes}
											noResultsMessage="Типы авто не найдены"
											search
											isWithoutSelectOnBlur
											onChange={() => handleFieldChange('car_type_id', index)}
											isWithoutErrorText
										/>
									</div>

									<div className="dictionary-about-form__block_transport-field_tonnage">
										<Field
											key={`tonnage_${row.id}`}
											name={`transports[${index}].tonnage_id`}
											type="text"
											component={FormSelectField}
											autoComplete="off"
											placeholder="Тонн-ть"
											options={tonnages}
											loading={isOptionsListLoading.tonnages}
											disabled={isOptionsListLoading.tonnages}
											noResultsMessage="Тоннажности не найдены"
											search
											isWithoutSelectOnBlur
											onChange={() => handleFieldChange('tonnage_id', index)}
											isWithoutErrorText
										/>
									</div>

									<div className="dictionary-about-form__block_transport-field_quantity">
										<Field
											key={`quantity_${row.id}`}
											name={`transports[${index}].quantity`}
											type="text"
											component={FormInputField}
											normalize={normalizeInteger}
											autoComplete="off"
											placeholder="Кол-во"
											unit="шт"
											onChange={() => handleFieldChange('quantity', index)}
											isWithoutErrorText
										/>
									</div>

									<div className="dictionary-about-form__block_remove">
										{isLastRow && (
											<div
												className="dictionary-about-form__remove-button"
												onClick={() => onRemoveCarRow(index)}
											/>
										)}
									</div>
								</div>
								<Field name={`transports[${index}].car_type_id`} component={ErrorComponent} />
								<Field name={`transports[${index}].tonnage_id`} component={ErrorComponent} />
								<Field name={`transports[${index}].quantity`} component={ErrorComponent} />
							</div>
						</>
					);
				})}
				<Field name="transportsError" component={ErrorComponent} />
			</div>

			<div className="dictionary-about-form__row">
				<div className="dictionary-about-form__container_button">
					<div className="dictionary-about-form__add-car-button" onClick={onAddCarTypeButtonClick}>
						Добавить тип авто
						<button type="button" aria-label="Добавить тип авто" />
					</div>
				</div>
			</div>
		</section>
	);
};

CarFleetField.propTypes = {
	carFleetRows: PropTypes.array.isRequired,
	carTypes: PropTypes.array,
	tonnages: PropTypes.array,
	isOptionsListLoading: PropTypes.shape({
		carTypes: PropTypes.bool.isRequired,
		tonnages: PropTypes.bool.isRequired,
	}).isRequired,
	onAddCarTypeButtonClick: PropTypes.func.isRequired,
	onRemoveCarRow: PropTypes.func.isRequired,
	meta: PropTypes.object.isRequired,
	handleFieldChange: PropTypes.func.isRequired,
};
